<template lang="pug">
	nav#sfc-mobile-menu
		.menu-container
			.h-content
				.second-item-new-menu(:class="{'open-mobile': isOpenMobile}")
					a(href="/")
						sfc-logo-mobile.sfc-logo-mobile
				.first-item-new-menu(:class="{'open-mobile': isOpenMobile}")
					.options(:class="{'open-mobile': isOpenMobile}")
						span(v-bind:style='{"display" : (isSelected? "flex" : "none")}' @click="hideSubelementMobile()")
							left-arrow-icon
						a.search-link(href="/search" @click="trackAction('Menu Navigation Click', {'title': 'Search'})" v-if="!isSelected")
							search-icon
						span(v-if="!isOpenMobile" @click="showMenuMobile()")
							hamburger-icon.hamburger-icon
						span(v-else @click="showMenuMobile()")
							close-icon.close-icon
					.container-mobile(:class="{'open-mobile': isOpenMobile}")
						.menu-mobile
							ul
								li.item.main-option-mobile(v-bind:style='{"display" : (isActive? "flex" : "none")}')
									a.home(href="/")
										span.title-submenu
											| Home
								li.item.main-option-mobile(v-for="menu of menuJson" v-if="menu.title != 'Login' && menu.title != 'Search'" :key="'mobile-' + menu.id" :class="{'is-selected': menu.clicked}" v-bind:style='{"display" : (isActive ? "flex" : "none")}' @click="showSubelementMobile(menu); trackAction('Menu Navigation Click', {'title': `${menu.title}`})")
									span.title-submenu(v-if="!isSelected")
										| {{menu.title}}
									span(v-if="!isSelected")
										right-arrow-icon

									.sub-menu-mobile(v-if="menu.children.length > 0 && menu.title != 'Search'")
										a.title-submenu(:href="menu.url")
											| {{menu.title}}
											right-arrow-icon-blue
										.menu-wrap-mobile
											.item.menu-subtitle-mobile
												.wrap-option-mobile(v-for="submenu of menu.children" :key="'mobile-' + submenu.id")
													ul.sub-menu2-mobile(v-if="submenu.children")
														span.title-category
															| {{submenu.title}}
														li.item.menu-option-mobile(v-for="child of submenu.children" v-if="child.show_logged_out" :key="'mobile-' + child.id" :class="{'subscription-link': child.title == 'Subscribe'}")
															a(v-if="child.id == '23'" :href="child.url" :class="{'active': currentUrl == trimmedUrl(child.url)}" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
																| {{child.title}} {{currentYear}}
															a(v-else :href="child.url" :class="{'active': currentUrl == trimmedUrl(child.url)}" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
																| {{child.title}}
														no-ssr(v-for="child of submenu.children" v-if="$store.state.userIsLoggedIn && !child.show_logged_out" :key="'mobile-' + child.id")
															li.menu-option-mobile.no-ssrr
																a(:href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
																	| {{child.title}}
								no-ssr
									li.item.main-option-mobile.no-ssrr(v-for="menu of menuJson" v-if="menu.title == 'Login' && $store.state.userIsLoggedIn" :key="'mobile-' + menu.id" :class="{'is-selected': menu.clicked}" v-bind:style='{"display" : (isActive ? "flex" : "none")}' @click="showSubelementMobile(menu)")
										span.title-submenu(v-if="!isSelected")
											| Account
										right-arrow-icon(v-if="!isSelected")
										.sub-menu-mobile
											.menu-wrap-mobile
												.item.menu-subtitle-mobile
													.wrap-option-mobile.account
														span.title-category
															| Account
														ul.sub-menu2-mobile
															li.item.menu-option-mobile
																a(href="/manage_account/")
																	| Manage Account
															li.item.menu-option-mobile
																a(:href="logoutUrl")
																	| Log out
							span.title-category(v-bind:style='{"display" : (isActive? "flex" : "none")}')
								| Quick links
							ul.quick-links(v-bind:style='{"display" : (isActive? "flex" : "none")}')
								li
									a.cursor-pointer.link-inline(href='/intro-to-529s/which-is-the-best-529-plan-available' target='_self')
										| Best 529 plans of 2024
								li
									a.cursor-pointer.link-inline(href='/529-plan-details' target='_self')
										| Your state&apos;s 529 plan
								li
									a.cursor-pointer.link-inline(href='/compare-529-plans' target='_self')
										| Compare 529 plans
							.actions(v-bind:style='{"display" : (isActive? "flex" : "none")}')
								no-ssr
									.btn(v-if='!$store.state.userIsLoggedIn')
										a.login-btn(href='/login/' @click="trackData('Login - Advisor')")
											| Login
								.btn.get-started
									a.get-btn(href='/?savings-center=true' @click='trackSavingsCenter()') Get started

					.blocker(@click="showMenuMobile()" :class="{'open-mobile': isOpenMobile}")

</template>

<style lang="stylus">
	.menu-savings-center-spinner
		display: inline-block
</style>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

	#sfc-mobile-menu
		width: 100%
		background-color: #fff
		color: sfc-new-black
		display: flex
		@media(min-width: 1215px)
			display: none
		.menu-container
			max-width: 1348px
			display: flex
			display: -webkit-flex
			width: 100%
			margin: 0 auto
			.h-content
				align-items: center
				width: 100%
				display: flex
				display: -webkit-flex
				flex-wrap: wrap
				-webkit-flex-wrap: wrap
				align-content: center
				height: 74px!important
				justify-content: space-between
				padding: 15px 20px

				.first-item-new-menu
				.second-item-new-menu
					display: flex
					align-items: center

				.first-item-new-menu
					a.search-link
						svg
							vertical-align: middle
					.options
						display: flex
						display: -webkit-flex
						align-items: center
						span
							&:last-of-type
								svg
									margin-left: 20px
						.hamburger-icon
						.close-icon
							cursor: pointer
							width: auto
							height: 24px
						&.open-mobile
							justify-content: space-between
							width: 100%

					.container-mobile
						display: none
						&.open-mobile
							display: flex
							flex-direction: column
							width: 0
						.menu-mobile
							position: fixed
							z-index: 998
							margin-top: 37px
							background-color: #fff
							right: 0
							width: 400px
							padding: 15px 20px 60px 20px
							height: 100%
							overflow-y: auto
							display: flex
							flex-direction: column
							@media(max-width: 990px)
								width: 100%
							ul
								list-style: none
								padding-left: 0
								margin: 0
								li.main-option-mobile
									display: flex
									padding: 10px 0px
									list-style: none
									line-height: 140%
									cursor: pointer
									display: flex
									justify-content: space-between
									a
										text-decoration: none !important
										font-size: body-font-size-md
										color: sfc-new-black
										&.home
											text-decoration: none
									.title-submenu
										font-feature-settings: 'clig' off, 'liga' off
										color: sfc-new-black
										font-family: 'Dazzed', sans-serif!important
										font-size: 24px
										font-style: normal
										font-weight: 600
										-webkit-font-smoothing: antialiased
										-moz-osx-font-smoothing: grayscale
										line-height: 33.6px
									.sub-menu-mobile
										display: none
										flex-direction: column
										flex: 1
										.menu-wrap-mobile
											.item.menu-subtitle-mobile
												.wrap-option-mobile
													margin-top: 50px
													&:first-of-type
														margin-top: 0
													&:last-of-type
														margin-bottom: 60px
													&.account
														margin-top: 0
														.sub-menu2-mobile
															margin-top: 20px
									&.is-selected
										display: flex !important
										flex-direction: column
										border: none
										padding-top: 0
										.title-submenu
											display: flex
											align-items: center
											color: var(--black-500, #141414)!important
											text-decoration: underline!important
											text-decoration-color: #145EE5!important
											text-underline-offset: 2px
											margin-bottom: 50px
											svg
												margin-left: 5px
										.sub-menu-mobile
											display: flex
											ul.sub-menu2-mobile
												margin: 0
												height: auto
												display: flex
												flex-flow: column
												width: 100%
												padding: 0
												li.menu-option-mobile
													list-style: none
													margin-top: 12px
													&:first-of-type
														margin-top: 0
													a
														font-family: main-font
														font-size: 18px
														font-weight: 400
														line-height: 1.6
														letter-spacing: normal
														color: sfc-new-black!important
														outline: none
														cursor: pointer
														text-decoration: underline!important
														text-decoration-color: sfc-new-blue!important
														text-underline-offset: 2px
														margin-top: 50px
												
											.title-category
												margin-top: 0
												margin-bottom: 20px

								.button
									margin: 34px auto 60px
									>>>.sfc-simple-button
										width: 200px
										margin: 0 auto
						ul.quick-links
							display: flex
							flex-direction: column
							li
								margin-top: 20px
								a
									font-family: main-font
									font-size: 18px
									font-weight: 400
									line-height: 1.6
									letter-spacing: normal
									color: sfc-new-black!important
									outline: none
									cursor: pointer
									text-decoration: underline!important
									text-decoration-color: sfc-new-blue!important
									text-underline-offset: 2px
						.title-category
							font-feature-settings: "clig" off, "liga" off
							color: sfc-new-blue!important
							font-family: main-font
							font-size: body-font-size-sm
							font-style: normal
							font-weight: 600
							line-height: 160%
							margin-top: 30px
						.actions
							display: flex
							flex-direction: row
							width: 100%
							margin: 30px 0 60px 0
							padding-bottom: 30px
  							.btn
								margin: auto
								height: 50px
								text-align: center
								align-content: center
								border-radius: 10px
								flex: 1
								background-color: #fff
								border: 2px solid sfc-new-blue
								&.get-started
									background-color: sfc-new-blue
								&:first-of-type
									margin-right: 10px 
								a.login-btn
									text-decoration: none!important
									color: sfc-new-blue!important
									font-family: main-font
									font-size: 18px!important
									font-weight: 600
									line-height: 1.6
									&:hover
										background-color: sfc-new-white-hover
								a.get-btn
									text-decoration: none!important
									color: #ffffff!important
									font-family: main-font
									font-size: 18px!important
									font-weight: 600
									line-height: 1.6
									background-color: sfc-new-blue
									&:hover
										background-color: sfc-new-blue-hover
					.blocker
						visibility: hidden
						position: fixed
						top: 74px
						right: 375px
						bottom: 0
						left: 0
						content: ' '
						background: rgba(0,0,0,.3)
						z-index: 100
						@media(max-width: 990px)
							display: none!important
						&.open-mobile
							visibility: visible
					&.open-mobile
						@media(max-width: 990px)
							width: 100%
					
				.first-item-new-menu.open-mobile
					width: 100%
					max-width: 365px
					@media(max-width: 990px)
							max-width: unset
				.second-item-new-menu
					flex-grow: unset
					justify-content: center
					svg.sfc-logo-mobile
						width: auto
						height: 45px
					&.open-mobile
						@media(max-width: 990px)
							display: none!important

</style>

<script>
	import HamburgerIcon from '@/common/components/icons/redesign-v1/hamburger-icon-black'
	import SfcLogoMobile from '@/common/components/icons/redesign-v1/sfc-logo-mobile-black'
	import CloseIcon from '@/common/components/icons/redesign-v1/close-icon-black'
	import SearchIcon from '@/common/components/icons/redesign-v1/search-icon-black'
	import LeftArrowIcon from '@/common/components/icons/redesign-v1/left-arrow-icon'
	import RightArrowIcon from '@/common/components/icons/redesign-v1/right-arrow-icon'
	import RightArrowIconBlue from '@/common/components/icons/redesign-v1/right-arrow-icon-blue'
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import MenuJSON from '@/menu-footer.json'

	export default {

	components:{
		HamburgerIcon,
		SfcLogoMobile,
		CloseIcon,
		SearchIcon,
		LeftArrowIcon,
		RightArrowIcon,
		RightArrowIconBlue,
		SfcSimpleButton,
		MenuJSON
	},


	data() {
		return {
			currentYear: '',
			isSelected: false,
			isOpenMobile: false,
			isActive: true,
			back: false,
			loadingSavingsCenterUser: false,
			savingsCenterFlow: false,
			logoutUrl: '/logout/',
			menuJson: MenuJSON['menu'],
			fadeAway: false,
			lastScroll: 0
		}
	},

	methods: {

		async openSavingsCenter(){
			let nextPageUrl = false

			nextPageUrl = await this.nextStep()

			if(nextPageUrl){
				window.location.href = nextPageUrl
			}else{
				setTimeout(()=>{
					this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
				},0)
			}
		},

		async nextStep(){
			const token = this.$cookies.get("sfc_primary")
			let collegeSavingsUser = undefined

			if (token){
				if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
					return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			else{
				return false
			}

			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`

			this.loading = true
			try {
				const result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
			}
			this.loading = false

			if(!collegeSavingsUser)	return false

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

			return "/savings-center/" + collegeSavingsUser.next_step_v3
		},

		trackAction(eventDescription, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, "Navigation", "2", additionalInformation)
		},

		showMenuMobile(){
			if(!this.isOpenMobile){
				this.isOpenMobile = true
			}else{
				this.isOpenMobile = false
				this.isSelected = false
				this.isActive = true
				for(const m of this.menuJson){
					m.clicked = false
				}
				this.back = false
			}

			if (this.isOpenMobile) {
				document.querySelector('html').classList.add("noscroll")
				document.body.classList.add("noscroll")
			}else{
				document.querySelector('html').classList.remove("noscroll")
				document.body.classList.remove("noscroll")
				document.body.scrollTop = this.lastScroll
			}
		},

		handleOnScroll(e){
			if(this.isOpenMobile){
				e.stopPropagation()
				e.preventDefault()
				return false
			}
			const currentScroll = document.documentElement.scrollTop || document.body.scrollTop

			const elem = document.querySelector('#sfc-mobile-menu')

			// Get height of navbar and current Y position
			const max = Math.max( elem.scrollHeight, elem.offsetHeight, elem.clientHeight) + elem.getBoundingClientRect().top

			// Check if scroll positions changed
			if(currentScroll != this.lastScroll){
				// Fade away the menu if
				// Menu is not open
				// User is scrolling down
				// And scroll position is past by the initial height of the menu
				this.fadeAway = currentScroll > 0 && currentScroll >= max && this.lastScroll < currentScroll && this.open == false && this.autohide == true
			}
			this.lastScroll = currentScroll
		},

		showSubelementMobile(menu){
			if(menu.clicked == false){
				if (((menu.title != "Search")&&(menu.title != "Login")) || ((menu.title == "Login")&&(this.$store.state.userIsLoggedIn))){
					this.isSelected = true
					menu.clicked = true
					this.isActive =!this.isActive
					for(const m of this.menuJson){
						if(m.title != menu.title){
							m.clicked = false
						}
					}
					this.back = true
				}else{
					if (menu.title == "Search"){
						window.location.href = '/search';
					}else{
						if((menu.title == "Login")&&(!this.$store.state.userIsLoggedIn)){
							this.openLogin()
						}
					}
				}
			}else{
				this.isSelected = false
				menu.clicked = false
				this.isActive =!this.isActive
				this.back = false
			}
		},

		hideSubelementMobile(){
			for(const m of this.menuJson){
				if(m.title != menu.title){
					m.clicked = false
				}
			}
			this.isSelected = false
			parent.clicked = false
			this.isActive = !this.isActive
			this.back = false
		},

		openLogin(){
			window.location.href = '/login'
		},

		obModalShow(){
			this.savingsCenterFlow = false
		},
		trimmedUrl(url){
			return url.replace(/\/$/, "")
		}

	},

	computed: {
		currentUrl(){
			return this.$route.path.replace(/\/$/, "")
		}
	},

	mounted() {
		window.addEventListener('scroll', this.handleOnScroll, { passive: false });
		document.body.addEventListener('touchmove', this.preventScroll, { passive: false });

		this.logoutUrl = `/logout/?return_url=${window.location.href}`

		this.currentYear = new Date().getFullYear()
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.handleOnScroll, { passive: false });
		document.body.removeEventListener('touchmove', this.preventScroll, { passive: false });
	}
}
</script>
